import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-trino-cream relative" data-id="element-128">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl border border-trino-gold/20 relative" data-id="element-130">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-trino-gold/20" data-id="element-131" />

          <div className="relative z-10 text-center" data-id="element-132">
            <p className="text-xl sm:text-2xl font-serif text-trino-dark leading-relaxed mb-8 pt-4" data-id="element-133">
              "En los primeros 7 días de aplicar tu Perfil Trino, notarás que la
              resistencia interna desaparece. Decisiones que antes te tomaban
              meses, ahora se vuelven obvias porque comprendes qué energía estás
              activando."
            </p>
            <div className="inline-block bg-trino-peach/30 px-6 py-2 rounded-full" data-id="element-134">
              <p className="text-trino-burgundy font-bold text-lg" data-id="element-135">
                Es pasar de caminar a ciegas a tener un GPS de alta precisión.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}